import { takeLatest, call, put } from 'redux-saga/effects';
import { GET_BANNERS_START, PUT_BANNERS_ERROR, PUT_BANNERS_START, PUT_BANNERS_SUCCESS } from '../../types';

import apiCall from '../../../api';

export function* edit({ payload }) {
  try {
    const url = `/banners/update/${payload.id}`;
    const method = 'PUT';
    const data = payload.data;
    const headers = {Authorization: `Bearer ${payload.token}`};
    const results = yield call(apiCall, url, method, data, headers);
    console.log(results)
    yield put({ type: PUT_BANNERS_SUCCESS, results: results.data });
    
  } catch (error) {
    console.log(error)
    yield put({ type: PUT_BANNERS_ERROR, error });
  } finally {
    yield put({ type: GET_BANNERS_START, payload: {lang: null, token: payload.token} });
    payload.navigate(-1);
  }
}

export default function* put_banners() {
  yield takeLatest(PUT_BANNERS_START, edit);
}